import css from "styled-jsx/css";

export const componentStyles = css`
  .simpo-core-wrapper {
    .action-bar-wrapper {
      min-height: 150px;
    }
  }
`;
